"use strict";
/**
 * <h4>Customer configuration</h4>
 *
 * The package includes a basic configuration element that allows you to access the Quarticon system.
 *
 * Each request to the Quarticon system needs an indication of the configuration it will be using.
 * It is necessary to have <b>the customer symbol</b> and <b>the url address</b> under which the service is provided.
 *
 * The basic element is the {@link Config} class, which in the constructor will take the necessary configuration ({@link ConfigParams}) data to start using the Quarticon system
 *
 * An example of creating a configuration class:
 * ```
 * const customerConfiguration = new Config(customerConfigurationParameters: ConfigParams)
 * ```
 *
 * @packageDocumentation
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
var Config_1 = require("./Config");
Object.defineProperty(exports, "Config", { enumerable: true, get: function () { return Config_1.Config; } });
//# sourceMappingURL=index.js.map